import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import MyOrders from "../components/MyOrders";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { AuthProvider } from "../admin/context/AuthContext";

const MyOrdersPage = () => {
    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#299E60" />

            {/* Preloader */}
            <Preloader />

            {/* HeaderOne */}
            <HeaderOne />

            {/* Breadcrumb */}
            <Breadcrumb title={"Mes Commandes"} />

            {/* MyOrders - Wrapped with AuthProvider */}
            <AuthProvider>
                <MyOrders />
            </AuthProvider>

            {/* ShippingOne */}
            <ShippingOne />

            {/* FooterOne */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default MyOrdersPage;
